import BaseSelectBox from 'components/atoms/base-select-box';
import { useMemo, type FC } from 'react';
import { numberOfCallsDataSource } from 'infrastructure/data-sources/number-of-calls';

import type { INumberOfCallsItem } from 'infrastructure/data-sources/number-of-calls';
import type {
  IBaseSelectBoxOption,
  IBaseSelectBoxProps,
} from 'components/atoms/base-select-box/types';

type Options = IBaseSelectBoxOption<
  INumberOfCallsItem['id'],
  INumberOfCallsItem
>[];

interface NumberOfCallsSelectBoxProps
  extends Omit<IBaseSelectBoxProps<INumberOfCallsItem['id']>, 'options'> {
  withNone?: boolean;
}

export const NumberOfCallsSelectBox: FC<NumberOfCallsSelectBoxProps> = (
  props,
) => {
  const { withNone = true } = props;
  const dataSource = useMemo(
    () => numberOfCallsDataSource(withNone),
    [withNone],
  );

  const options: Options = useMemo(
    () =>
      dataSource.map((el) => ({
        value: el.id,
        label: el.name,
        record: el,
      })),
    [dataSource],
  );

  return <BaseSelectBox options={options} {...props} />;
};
